<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    :title="$t('Tenders.Download')"
    :without_second_btn="more_than_possible"
    @close="close">
    <sButton
      slot="first_btn"
      data-qa="btn-dialog-template-first"
      :disabled="disabled"
      :loading="loading"
      @click="apply">
      {{ more_than_possible ? $t('Tenders.ReturnToSelection') : $t('Tenders.Generate') }}
    </sButton>
    <template #activator-btn>
      <TooltipedBtn
        data-qa="btn-export-to-excel"
        :disabled="loading || disabled"
        icon="excel"
        :loading="loading"
        :small-btn="true"
        :text="$t('Tenders.Download')"
        :texted="$vuetify.breakpoint.lgAndUp"
        @click="open"/>
    </template>
    <template #card-text>
      <v-card-text class=" h6-text black--text pa-0">
        <div class="mb-3">
          {{ $t('Tenders.SelectedTenders', {count: filtred_count} ) }}
        </div>
        <sRadioGroup
          v-model="download_type"
          class="mt-3 h7-text "
          column
          :disabled="loading">
          <sRadio
            v-for="item in download_types"
            :key="item.value"
            class="black--text"
            color="var(--black-color)"
            data-qa="download_type"
            :label="item.value">
            {{ item.title }}
          </sRadio>
        </sRadioGroup>
        <div class="mt-3">
          {{ $t('Common.Add') }}
        </div>
        <sCheckboxGroup
          v-model="checked_archive_types"
          class="mt-3"
          :disabled="loading">
          <sCheckbox
            v-for="item in archive_types"
            :key="item.value"
            :label="item.value">
            {{ item.title }}
          </sCheckbox>
        </sCheckboxGroup>
        <div v-if="max_count > 0">
          {{ $t('Tenders.MaximumTtendersForExport', {count: max_count } ) }}
        </div>
        <div v-if="more_than_possible">
          {{ $t('Tenders.ChangeSearchToExportTenders' ) }}
        </div>
      </v-card-text>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { findComponentsUpward, findComponentsDownward } from 'toolkit/utils/dom'

import { debounce } from 'toolkit/utils/util'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'downloadTendersToExcel',
  data() {
    return {
      dialog: false,
      loading: false,
      download_type: '',
      download_types: [
        { title: this.$t('Tenders.ReportWithoutLots'), value: 'EXCEL_REPORT' },
        { title: this.$t('Tenders.ReportWithLots'), value: 'EXCEL_REPORT_DETAILED' },
        { title: this.$t('Tenders.ReportWithLotsAndBinds'), value: 'EXCEL_REPORT_DETAILED_WITH_BIDS' }
      ],
      archive_types: [
        { title: this.$t('Tenders.TenderDocuments'), value: 'TENDER_DOCUMENTS' },
        { title: this.$t('Tenders.DocumentsFromSupplier'), value: 'BIDS_DOCUMENTS' },
        { title: this.$t('Tenders.ComparativeTableCase'), value: 'COMPARISON_TABLE' }
      ],
      checked_archive_types: []
    }
  },
  props: {
    filtred_count: Number,
    search: Object,
    disabled: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
    max_count() {
      return this.checked_archive_types.length > 0 ? 100000 : 0
    },
    more_than_possible() {
      return this.max_count > 0 && this.filtred_count > this.max_count
    },
    key() {
      return `tender-${this.fileProps.downloadType}-${this.fileProps.addTenderDocs ? 'addTenderDocs' : ''}-${this.fileProps.addBidsDocs ? 'addBidsDocs'  : ''}-${this.fileProps.addComparisonTable ? 'addComparisonTable' : ''}-file`
    },
    fileProps() {
      return {
        downloadType: this.download_type,
        addTenderDocs: this.checked_archive_types.includes('TENDER_DOCUMENTS'),
        addBidsDocs: this.checked_archive_types.includes('BIDS_DOCUMENTS'),
        addComparisonTable: this.checked_archive_types.includes('COMPARISON_TABLE')
      }
    }
  },
  methods: {
    isExistFile() {
      const defaultApp = findComponentsUpward(this, 'layout')
      if (!defaultApp?.length) {
        return false
      }
      const downloadFiles = findComponentsDownward(defaultApp[0], 'downloadFiles')
      if (!downloadFiles?.length) {
        return false
      }
      if (downloadFiles[0].files[this.key]) {
        return true
      }
      return false
    },
    open() {
      this.dialog = true
    },
    close() {
      this.loading = false
      this.dialog = false
    },
    apply: debounce(async function () {
      if (this.isExistFile()) {
        this.$notice.info({
          title: this.$t('Tenders.Download'),
          message: this.$t('Tenders.fileAlreadyCreated'),
          duration: 10
        })
        return
      }
      this.loading = true
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Завантаження тендерів')
        return
      } else if (!this.more_than_possible) {
        await this.$notifier.geterateTendersToExcel(
          'Tenders.'.concat(this.checked_archive_types.length > 0 ? 'zip' : 'xlsx'),
          this.search,
          ...Object.values(this.fileProps)
        )
      }
      this.close()
    }, 250),
  },
  mounted() {
    this.download_type = this.download_types[0].value
  },
  components: {
    TooltipedBtn,
    DialogTemplateToolkit
  }
}
</script>
